export default "__VITE_ASSET__mqJCk4vu__"